<template v-slot:listItem="{ item }" >
  <div class="list-item">
    <div class="list-item-first-line">
      <div class="block-row">
        <span class="block-row-label">{{item.descricao}}</span>
        <div class="block-row-content" :class="formataCor(item.evolucao, item.melhorResultado)">
          <span >{{formataValor(Math.abs(item.evolucao), '%')}}</span>
          <gw-icon :icon="defineIcone(item.evolucao, item.melhorResultado)"/>
        </div>
      </div>
    </div>
    <div class="list-item-second-line">
      <div class="block-column">
        <span class="block-column-label">Atual</span>

        <span class="block-column-content">{{formataValor(item.atual, item.formato)}}</span>
        <span v-if="item.detalheAtual" class="block-column-detail">
          {{formataValor(item.detalheAtual, item.detalheFormato)}}
        </span>
      </div>
      <div class="block-column">
        <span class="block-column-label">Anterior</span>
        <span class="block-column-content" >{{formataValor(item.anterior, item.formato)}}</span>
        <span v-if="item.detalheAnterior" class="block-column-detail" >
          {{formataValor(item.detalheAnterior, item.detalheFormato)}}
        </span>
      </div>
      <div class="block-column">
        <span class="block-column-label">Diferença</span>

        <div class="block-column-content":class="formataCor(item.diferenca, item.melhorResultado)">
          <span >{{formataValor(Math.abs(item.diferenca), item.formato)}}</span>
          <gw-icon class="icon-arrow":icon="defineIcone(item.diferenca, item.melhorResultado)"/>
        </div>
        <div v-if="item.detalheDiferenca" class="block-column-detail" >
          <span >{{formataValor(Math.abs(item.detalheDiferenca), item.detalheFormato) }}</span>
          <gw-icon class="icon-arrow":icon="defineIcone(item.detalheDiferenca, item.melhorResultado)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GwList,
  GwIcon,
  GwTextFilterItem
} from 'guaxinim-web'

import A7PainelAnaliseFormatacao from './A7PainelAnaliseFormatacao'

export default {
  name: "a7-painel-analise-item-mobile",
  components: {
    GwList,
    GwIcon,
    GwTextFilterItem
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({ }),
  methods: {
    defineIcone: A7PainelAnaliseFormatacao.defineIcone,
    formataValor: A7PainelAnaliseFormatacao.formataValor,
    formataCor: A7PainelAnaliseFormatacao.formataCor
  }
}
</script>

<style lang="scss" scoped>
@import './A7PainelAnaliseFormatacao';

$tamanhoFonteGrande: 1.2em;
$tamanhoFonteMedia: 1.1em;
$tamanhoFontePequena: 0.9em;
$weight: 600;
$color: rgba(140, 140, 140, 1);

.list-item {
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
  width: 100%;
}

.list-item-first-line{
  padding-bottom: 5px;
}

.list-item-second-line{
  display: flex;
}

.block-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.block-row-label{
  margin-right: 10px;
}
.block-row-label,
.block-row-content{
  font-size: $tamanhoFonteGrande;
  font-weight: $weight;
}

.block-column {
  display: flex;
  flex-direction: column;
  min-width: 33%;
}
.block-column-label{
  font-size: $tamanhoFontePequena;
  font-weight: $weight;
  color: $color
}
.block-column-content{
  font-size: $tamanhoFonteMedia;
  font-weight: $weight;
}
.block-column-detail{
  font-weight: $weight;
}

.icon-arrow {
  font-size: 17px;
}
</style>
